import React from "react";
import { CURRENCY } from "src/lib/constans";

interface IProps {
  regularPrice?: number;
  salePrice?: number | null;
  className?: string;
  regularClassName?: string;
  saleClassName?: string;
  fontFamily?: string;
  fontFamilyRegular?: string;
}

const PriceView = ({
  regularPrice,
  salePrice,
  className,
  regularClassName,
  saleClassName,
  fontFamily = "font-Suisse-Intl-Medium",
  fontFamilyRegular = "font-Suisse-Intl-Regular",
}: IProps) => {
  return (
    <div
      className={`flex items-center gap-2 text-[#004540] ${className}`}
    >
      <span className={`font-size-18px whitespace-nowrap ${fontFamily} ${saleClassName}`}>
        {CURRENCY}{" "}
        {salePrice
          ? parseFloat(salePrice.toString() || "0").toLocaleString()
          : parseFloat(regularPrice?.toString() || "0").toLocaleString()}
      </span>
      {regularPrice && salePrice && (
        <span
          className={`font-size-15px line-through text-[#3B3B3B] ${fontFamilyRegular} whitespace-nowrap ${regularClassName}`}
        >
          {CURRENCY} {parseFloat(regularPrice.toString() || "0").toLocaleString()}
        </span>
      )}
    </div>
  );
};

export default PriceView;
